import { type TitleTopBar } from "~/components/Components/TitleTopBar/TitleTopBar";
import { TopBar } from "~/components/Components/TopBar/TopBar";

type Props = {
  topBarProps: React.ComponentProps<typeof TitleTopBar>;
};

export const MyPageTopBarModule = (props: Props) => {
  return <TopBar barType="title" topBarProps={props.topBarProps} />;
};
